import * as React from "react";
import { DocumentsTableItem } from "Pages/Project/Documents/Stores/DocumentsTableStore";
import { TableRowProps } from "react-virtualized/dist/es/Table";

export interface DraggableTableRowProps extends TableRowProps {
  onDrag?: (e: React.DragEvent) => void;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: (e: React.DragEvent) => void;
  // pick row data that is passed through dataset of dragged row
  normalizeDropRowData?: (rowData: DocumentsTableItem) => void;
  // should return true if row is allowed to be dragged
  getDraggableFromRowData?: (rowData: DocumentsTableItem) => boolean;
  // should return true if row is allowed to consume dragged row
  getDroppableFromRowData?: (rowData: DocumentsTableItem) => boolean;
}

export function dndRowRenderer({
  className,
  columns,
  index,
  key,
  onRowClick,
  onRowDoubleClick,
  onRowMouseOut,
  onRowMouseOver,
  onRowRightClick,
  rowData,
  style,
  onDrag,
  onDragStart,
  onDragEnd,
  normalizeDropRowData,
  getDraggableFromRowData,
  getDroppableFromRowData,
}: DraggableTableRowProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const a11yProps: any = { "aria-rowindex": index + 1 };

  let dataRowdata: string;
  let draggable: boolean;
  const dragEvents: Pick<
    React.DOMAttributes<HTMLDivElement>,
    "onDragStart" | "onDragEnd" | "onDragEnter" | "onDragLeave" | "onDrop" | "onDrag"
  > = {};
  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps["aria-label"] = "row";
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = (event) => onRowClick({ event, index, rowData });
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = (event) => onRowDoubleClick({ event, index, rowData });
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = (event) => onRowMouseOut({ event, index, rowData });
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = (event) => onRowMouseOver({ event, index, rowData });
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = (event) => onRowRightClick({ event, index, rowData });
    }
    if (normalizeDropRowData) {
      dataRowdata = JSON.stringify(normalizeDropRowData(rowData));
    } else {
      dataRowdata = JSON.stringify({ id: rowData.id });
    }
    if (getDraggableFromRowData) {
      draggable = getDraggableFromRowData(rowData);
    } else {
      draggable = true;
    }
    if (draggable) {
      dragEvents.onDrag = onDrag;
      dragEvents.onDragStart = onDragStart;
      dragEvents.onDragEnd = onDragEnd;
    }
    if (getDroppableFromRowData && getDroppableFromRowData(rowData)) {
      dragEvents.onDragEnter = (e) => e.currentTarget.classList.add("droppable-row");
      dragEvents.onDragLeave = (e) => e.currentTarget.classList.remove("droppable-row");
      dragEvents.onDrop = (e) => {
        e.currentTarget.classList.remove("droppable-row");
        return e;
      };
    }
  }

  return (
    <div
      {...a11yProps}
      className={className}
      key={key}
      role="row"
      draggable={draggable}
      {...dragEvents}
      data-rowdata={dataRowdata}
      style={style}
    >
      {columns}
    </div>
  );
}
